import React, { useState } from 'react';
import { Search, X } from 'lucide-react';
import { useSupabaseSearch } from '../context/SupabaseSearchContext';

export function SearchBar() {
  const { query, setQuery, setSearchFilters } = useSupabaseSearch();
  const [localQuery, setLocalQuery] = useState(query);

  // Handle input change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalQuery(value);
  };

  // Execute search with current query
  const executeSearch = () => {
    setQuery(localQuery || " "); // Use a space if query is empty to force a search
  };

  const clearSearch = () => {
    setLocalQuery('');
    setQuery('');
    setSearchFilters({
      onlyActive: false,
      region: '',
      purpose: ''
    });
  };

  return (
    <div className="w-full transform transition-all">
      <div className="flex flex-grow">
        <div className="relative flex flex-grow">
          <div className="absolute inset-y-0 left-0 pl-3 sm:pl-4 flex items-center pointer-events-none">
            <Search className="h-4 w-4 sm:h-5 sm:w-5 text-[#A3C1DA]" aria-hidden="true" />
          </div>
          <input
            type="text"
            value={localQuery}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                executeSearch();
              }
            }}
            placeholder="Sök efter stiftelser..."
            className="search-input block w-full pl-10 sm:pl-11 pr-10 py-3 sm:py-4 border-0 rounded-l-xl
                      bg-white/95 backdrop-blur-sm shadow-lg text-sm sm:text-base
                      placeholder-gray-400 focus:outline-none focus:ring-2 
                      focus:ring-[#A3C1DA] focus:ring-offset-2 focus:ring-offset-[#A3C1DA]
                      text-gray-900 transition-all
                      hover:shadow-xl"
            aria-label="Sök efter stiftelser"
          />
          <div className="absolute inset-y-0 right-0 flex items-center mr-3">
            {localQuery && (
              <button 
                onClick={clearSearch}
                className="p-1 rounded-md text-gray-400 hover:text-gray-600 focus:outline-none"
                aria-label="Rensa sökning"
              >
                <X className="h-5 w-5" />
              </button>
            )}
          </div>
        </div>
        
        {/* Search button */}
        <button
          onClick={executeSearch}
          className="py-3 px-6 sm:px-8 bg-[#A3C1DA] text-white rounded-r-xl hover:bg-[#92B0C9] transition-colors shadow-lg hover:shadow-xl"
          aria-label="Sök"
        >
          Sök
        </button>
      </div>
    </div>
  );
}
